import { PUBLIC_PAGES } from '../config/publicPages.js';
import {
  absoluteUrl,
  DEFAULT_OG_IMAGE,
  DEFAULT_SITE_URL,
  SITE_NAME,
} from './blogSeo.js';

export const normalizePublicPath = (path = '/') =>
  path.split(/[?#]/)[0].replace(/\/+$/, '') || '/';

export const buildPublicPageMetaTags = (path, siteUrl = DEFAULT_SITE_URL) => {
  const page = PUBLIC_PAGES.find(
    (entry) => entry.path === normalizePublicPath(path)
  );
  if (!page) return null;

  const url = absoluteUrl(page.path, siteUrl);
  const image = absoluteUrl(DEFAULT_OG_IMAGE.path, siteUrl);
  return {
    title: page.title,
    meta: [
      { name: 'title', content: page.title },
      { name: 'description', content: page.description },
      { name: 'robots', content: 'index, follow' },
      { property: 'og:type', content: 'website' },
      { property: 'og:site_name', content: SITE_NAME },
      { property: 'og:url', content: url },
      { property: 'og:title', content: page.title },
      { property: 'og:description', content: page.description },
      { property: 'og:image', content: image },
      { property: 'og:image:width', content: String(DEFAULT_OG_IMAGE.width) },
      { property: 'og:image:height', content: String(DEFAULT_OG_IMAGE.height) },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: page.title },
      { name: 'twitter:description', content: page.description },
      { name: 'twitter:image', content: image },
    ],
    link: [{ rel: 'canonical', href: url }],
  };
};

// Used by Firebase's SPA fallback, including articles published after a build.
// Do not declare the homepage canonical here, or noindex future articles before
// Vue has had a chance to fetch them.
export const buildAppShellMetaTags = () => ({
  title: SITE_NAME,
  meta: [],
  link: [],
});
